<div class="min-h-screen flex flex-col bg-gray-50 w-full mx-auto font-prompt relative">
  <!-- 1. Header บาร์ด้านบน -->
  <div
    class="w-full bg-(--header-background) px-4 py-3 flex items-center justify-between sticky top-0 z-30 shadow-sm text-white select-none">
    <button (click)="goback()"
      class="flex items-center text-white hover:opacity-80 active:scale-95 transition-all outline-none">
      <span class="material-symbols-outlined text-xl">arrow_back</span>
    </button>
    <h1 class="text-sm font-bold tracking-wide" style="margin-bottom: 0;">
      {{ currentLanguage === 'TH' ? 'รถแชร์ร่วมกัน' : 'Vehicle Share' }}
    </h1>
    <div class="w-6"></div> <!-- Spacer -->
  </div>

  <!-- 2. กล่องควบคุมด้านบน: ค้นหา + ปุ่มกล่องจดหมายคำเชิญ -->
  <div class="px-4 mt-4 flex gap-2 items-center select-none">
    <div class="flex-grow relative">
      <span
        class="material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm">search</span>
      <input type="text" [(ngModel)]="valueFilterVehicleShare" (ngModelChange)="onFilterVehicleShare($event)"
        [placeholder]="currentLanguage === 'TH' ? 'กรอกเลขทะเบียนเพื่อค้นหา...' : 'Search plate number...'"
        class="w-full bg-white border border-gray-100 text-xs rounded-xl pl-9 pr-4 py-2.5 text-gray-800 outline-none shadow-sm focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all placeholder:text-gray-300" />
    </div>

    <!-- ปุ่มไปหน้าคำเชิญของฉัน (Inbox) -->
    <button (click)="goInbox()"
      class="shrink-0 flex items-center gap-1.5 px-3 py-2.5 rounded-xl bg-white border border-gray-100 shadow-sm text-xs font-bold text-gray-600 hover:text-amber-500 hover:border-amber-100 active:scale-95 transition-all outline-none relative">
      <span class="material-symbols-outlined text-base text-amber-500">mail</span>
      <span>{{ currentLanguage === 'TH' ? 'คำเชิญ' : 'Inbox' }}</span>
      <span *ngIf="pendingInboxCount > 0"
        class="absolute -top-1.5 -right-1.5 bg-red-500 text-white text-[8px] font-bold rounded-full w-4 h-4 flex items-center justify-center border border-white">
        {{ pendingInboxCount }}
      </span>
    </button>
  </div>

  <!-- 3. รายการรถแชร์ (Vehicle Groups List) -->
  <div class="flex-grow px-4 pt-4 pb-28 space-y-3 overflow-y-auto scroll-smooth select-none">
    <!-- กรณีไม่มีข้อมูลรายการกลุ่มแชร์ -->
    <div *ngIf="!(filteredVehicleShare ? filteredVehicleShare : vehicleShare)?.length"
      class="flex flex-col items-center justify-center py-20 text-center">
      <div class="w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center text-gray-400 mb-3 shadow-inner">
        <span class="material-symbols-outlined text-3xl">people_alt</span>
      </div>
      <p class="text-xs font-bold text-gray-400">{{ currentLanguage === 'TH' ? 'ยังไม่มีกลุ่มแชร์รถ' : 'No share groups
        yet' }}</p>
      <p class="text-[10px] text-gray-400 mt-1">{{ currentLanguage === 'TH' ?
        'คุณสามารถกดเพิ่มกลุ่มแชร์เพื่อแบ่งปันสิทธิ์การเข้าออกลานจอด' : 'You can create a share group to share parking
        access.' }}</p>
    </div>

    <!-- การ์ดรายการแต่ละคัน -->
    <div *ngFor="let vehicle of filteredVehicleShare ? filteredVehicleShare : vehicleShare"
      class="bg-white rounded-3xl p-5 border border-gray-100 shadow-sm relative hover:border-amber-200 hover:bg-amber-50/5 transition-all flex justify-between items-center group text-left">
      <div class="flex items-center gap-3">
        <!-- ไอคอนรถแชร์ -->
        <div
          class="w-10 h-10 rounded-full bg-amber-50 flex items-center justify-center text-amber-500 group-hover:scale-105 transition-transform flex-shrink-0">
          <span class="material-symbols-outlined text-lg">minor_crash</span>
        </div>
        <div class="space-y-1">
          <h3 class="text-xs font-bold text-gray-800 leading-tight">{{ vehicle.plateNumber }}</h3>
          <p class="text-[10px] text-gray-400 font-bold flex items-center gap-1">
            <span class="material-symbols-outlined text-[11px] text-gray-300">group</span>
            {{ currentLanguage === 'TH' ? 'สมาชิก: ' : 'Members: ' }} {{ vehicle.memberCount }} {{ currentLanguage ===
            'TH' ? 'คน' : 'peoples' }}
          </p>
        </div>
      </div>

      <!-- ปุ่มเปิดหน้าจัดการ (Manage) -->
      <button (click)="openManage(vehicle)"
        class="bg-slate-800 hover:bg-slate-700 text-white text-[10px] font-bold px-4 py-2 rounded-xl transition-all active:scale-95 outline-none">
        {{ currentLanguage === 'TH' ? 'จัดการ' : 'Manage' }}
      </button>
    </div>
  </div>

  <!-- 4. ปุ่มกลมเพิ่มสิทธิ์การเชิญใหม่ลอยคงที่มุมขวาล่าง -->
  <div class="fixed bottom-6 right-6 z-20" (click)="openInvite()">
    <button
      class="w-12 h-12 rounded-full bg-amber-400 hover:bg-amber-500 text-white flex items-center justify-center shadow-lg hover:shadow-xl active:scale-90 transition-all outline-none">
      <span class="material-symbols-outlined text-xl font-bold">add</span>
    </button>
  </div>
</div>

<!-- 5. MODAL MANAGE (Manage members popup) -->
<div *ngIf="modalManage && selectedGroup"
  class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm animate-fade-in p-4">
  <div
    class="bg-white rounded-[2rem] w-full max-w-sm max-h-[80vh] overflow-y-auto px-6 pt-6 pb-8 shadow-2xl flex flex-col text-left animate-scale-up relative">

    <!-- ปุ่มปิด -->
    <button (click)="closeManage()"
      class="absolute top-4 right-4 w-7 h-7 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-500 flex items-center justify-center transition-all active:scale-90 outline-none">
      <span class="material-symbols-outlined text-sm">close</span>
    </button>

    <!-- หัวข้อ -->
    <h2 class="text-sm font-bold text-gray-800 mb-4 pr-8">
      {{ currentLanguage === 'TH' ? 'จัดการการแชร์รถ' : 'Manage Shared Vehicle' }}
    </h2>

    <div class="space-y-4 flex-grow custom-scrollbar">
      <!-- ข้อมูลรถ -->
      <div class="p-3 bg-amber-50/50 border border-amber-100/50 rounded-2xl flex items-center gap-3">
        <span class="material-symbols-outlined text-lg text-amber-500">directions_car</span>
        <div>
          <span class="text-[9px] text-gray-400 block font-bold leading-none">{{ currentLanguage === 'TH' ? 'ทะเบียนรถ'
            : 'License Plate' }}</span>
          <span class="text-xs font-bold text-gray-700">{{ selectedGroup.plateNumber }}</span>
        </div>
      </div>

      <!-- ส่วนจัดการ สมาชิกปัจจุบัน -->
      <div>
        <div class="flex justify-between items-center mb-2">
          <h3 class="text-xs font-bold text-gray-700">
            {{ currentLanguage === 'TH' ? 'สมาชิกในกลุ่ม' : 'Current Members' }}
          </h3>
          <button (click)="openInvite(selectedGroup)"
            class="text-[9px] font-bold text-amber-600 bg-amber-50 hover:bg-amber-100 px-2.5 py-1 rounded-lg transition-colors outline-none">
            {{ currentLanguage === 'TH' ? '+ เชิญสมาชิก' : '+ Invite' }}
          </button>
        </div>

        <div class="space-y-2 max-h-36 overflow-y-auto custom-scrollbar">
          <div *ngFor="let m of members"
            class="flex justify-between items-center py-2 px-3 bg-gray-50/50 hover:bg-gray-50 border border-gray-100 rounded-xl transition-colors">
            <div>
              <p class="text-xs font-bold text-gray-800">{{ m.name || '-' }}</p>
              <p class="text-[9px] text-gray-400 capitalize font-bold leading-none mt-0.5">{{ m.role }}</p>
            </div>
            <button (click)="askRevoke(m)"
              class="text-[10px] font-bold text-red-500 bg-red-50 hover:bg-red-100 px-2 py-1 rounded-lg transition-colors outline-none">
              {{ currentLanguage === 'TH' ? 'ถอนสิทธิ์' : 'Revoke' }}
            </button>
          </div>
          <p *ngIf="!members.length" class="text-[10px] text-gray-400 text-center py-4">
            {{ currentLanguage === 'TH' ? 'ยังไม่มีสมาชิกอื่นในรถคันนี้' : 'No other members in this group' }}
          </p>
        </div>
      </div>

      <!-- ส่วนคิวเชิญค้างส่ง (Pending Invites) -->
      <div>
        <h3 class="text-xs font-bold text-gray-700 mb-2">
          {{ currentLanguage === 'TH' ? 'คำเชิญที่รอการตอบรับ' : 'Pending Invitations' }}
        </h3>

        <div class="space-y-2 max-h-32 overflow-y-auto custom-scrollbar">
          <div *ngFor="let inv of pendingInvites"
            class="flex justify-between items-center py-2 px-3 bg-gray-50/50 border border-gray-100 rounded-xl">
            <div>
              <p class="text-xs font-bold text-gray-800">{{ inv.toName || ('#' + inv.toCpUserId) }}</p>
              <p class="text-[9px] text-amber-500 font-bold leading-none mt-0.5">{{ inv.status }}</p>
            </div>
            <button (click)="cancelPending(inv)"
              class="text-[10px] font-bold text-gray-400 hover:text-red-500 px-2 py-1 rounded-lg transition-colors outline-none">
              {{ currentLanguage === 'TH' ? 'ยกเลิกเชิญ' : 'Cancel' }}
            </button>
          </div>
          <p *ngIf="!pendingInvites.length" class="text-[10px] text-gray-400 text-center py-4">
            {{ currentLanguage === 'TH' ? 'ไม่มีคำเชิญค้างส่ง' : 'No pending invites' }}
          </p>
        </div>
      </div>

      <!-- ปุ่มถอนตัวออกจากกลุ่ม / ยุบกลุ่มแชร์ -->
      <div class="flex gap-2 pt-2">
        <button (click)="leaveGroup(selectedGroup)"
          class="flex-1 py-2.5 rounded-xl border border-gray-200 text-gray-600 hover:bg-gray-50 text-xs font-bold transition-all active:scale-95 outline-none">
          {{ currentLanguage === 'TH' ? 'ออกจากแชร์' : 'Leave Group' }}
        </button>
        <button (click)="askDissolve()"
          class="flex-1 py-2.5 rounded-xl bg-red-50 hover:bg-red-600 text-white text-xs font-bold transition-all active:scale-95 outline-none">
          {{ currentLanguage === 'TH' ? 'ยุบกลุ่ม' : 'Dissolve Group' }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- 6. MODAL INVITE (Invite user modal) -->
<div *ngIf="modalInvite"
  class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm animate-fade-in p-4">
  <div class="bg-white rounded-[2rem] w-full max-w-sm p-6 shadow-2xl flex flex-col text-left animate-scale-up relative">

    <!-- ปุ่มปิด -->
    <button (click)="closeInvite()"
      class="absolute top-4 right-4 w-7 h-7 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-500 flex items-center justify-center transition-all active:scale-90 outline-none">
      <span class="material-symbols-outlined text-sm">close</span>
    </button>

    <!-- หัวข้อ -->
    <h2 class="text-sm font-bold text-gray-800 mb-4 pr-8">
      {{ currentLanguage === 'TH' ? 'ส่งคำเชิญแชร์รถยนต์' : 'Invite Member to Share' }}
    </h2>

    <div class="space-y-3">
      <!-- ทะเบียนรถ Custom autocomplete dropdown -->
      <div class="relative">
        <label class="block font-bold text-xs text-gray-600 mb-1.5">
          {{ currentLanguage === 'TH' ? 'เลือกทะเบียนรถยนต์' : 'Select Vehicle Plate' }}
        </label>
        <div class="relative">
          <input type="text" [(ngModel)]="vehicleSearchText" (focus)="openVehicleDropdown()"
            (blur)="closeVehicleDropdown()"
            placeholder="{{ currentLanguage === 'TH' ? 'เลือกทะเบียนรถ' : 'Select plate' }}"
            class="w-full bg-gray-50/50 border border-gray-200 text-xs rounded-xl px-3 py-2 text-gray-800 outline-none focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all placeholder:text-gray-300 cursor-pointer" />
          <span
            class="material-symbols-outlined absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm pointer-events-none">expand_more</span>
        </div>
        <!-- Dropdown Options List -->
        <div *ngIf="activeVehicleDropdown" (mousedown)="$event.preventDefault()"
          class="absolute z-50 left-0 right-0 mt-1 max-h-40 overflow-y-auto bg-white border border-gray-100 rounded-xl shadow-lg scroll-smooth py-1">
          <div *ngFor="let v of filteredVehicleOptions" (click)="selectVehicleOption(v)"
            class="px-4 py-2 text-xs text-gray-700 hover:bg-amber-50 hover:text-amber-600 cursor-pointer transition-colors">
            {{ vehicleLabel(v) }}
          </div>
          <div *ngIf="filteredVehicleOptions.length === 0" class="px-4 py-2 text-xs text-gray-400 text-center">
            {{ currentLanguage === 'TH' ? 'ไม่พบข้อมูลทะเบียน' : 'No matches found' }}
          </div>
        </div>
      </div>

      <!-- เบอร์โทรศัพท์ผู้รับ -->
      <div>
        <label class="block font-bold text-xs text-gray-600 mb-1.5">
          {{ currentLanguage === 'TH' ? 'เบอร์โทรศัพท์ผู้รับคำเชิญ' : 'Invitee Phone Number' }}
        </label>
        <input type="text" [(ngModel)]="invitePhone" (input)="onPhoneInput($event)" maxlength="10"
          placeholder="0812345678"
          class="w-full bg-gray-50/50 border border-gray-200 text-xs rounded-xl px-3 py-2 text-gray-800 outline-none focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all placeholder:text-gray-300" />
      </div>

      <!-- ปุ่มตกลงส่งคำเชิญ -->
      <button (click)="sendInvite()"
        class="w-full bg-(--main-color) hover:from-amber-600 hover:to-yellow-500 text-white text-xs font-bold rounded-xl py-3 shadow-[0_4px_12px_rgba(245,158,11,0.25)] transition-all duration-200 active:scale-95 outline-none mt-4">
        {{ currentLanguage === 'TH' ? 'ส่งคำเชิญแชร์สิทธิ์' : 'Send Invitation' }}
      </button>
    </div>
  </div>
</div>

<!-- ยืนยันการถอนสมาชิก -->
<app-pss-warn *ngIf="showConfirmRevoke" [isButtonConfirm]="true" [language]="currentLanguage"
  [text]="currentLanguage === 'TH' ? 'ถอนสมาชิก?' : 'Revoke member?'"
  [detail]="currentLanguage === 'TH' ? 'บัตรของสมาชิก (ถ้ามี) จะโอนกลับเจ้าของ' : 'Member cards for this plate will transfer to owner'"
  (submit)="confirmRevoke()" (close)="showConfirmRevoke = false"></app-pss-warn>

<!-- ยืนยันการยุบกลุ่ม -->
<app-pss-warn *ngIf="showConfirmDissolve" [isButtonConfirm]="true" [language]="currentLanguage"
  [text]="currentLanguage === 'TH' ? 'ยุบกลุ่มแชร์?' : 'Dissolve group?'"
  [detail]="currentLanguage === 'TH' ? 'หากสมาชิกยังถือบัตรรายเดือน อาจยุบไม่ได้' : 'Blocked if members still hold active monthly cards'"
  (submit)="confirmDissolve()" (close)="showConfirmDissolve = false"></app-pss-warn>